import * as React from "react";
import Booth from "../../_data/models/Booth";
import BreadcrumbsComponent from "../../_widgets/breadcrumbs/BreadcrumbsComponent";
import {ShopsRoutes} from "../../routes";
import Shop from "../../_data/models/Shop";
import {Link} from "react-router-dom";
import {Redirect} from "react-router";
import CarouselComponent from "../../_widgets/carousel/CarouselComponent";

interface Props {
    booth: Booth;
    shop: Shop;
}

export const BoothProfileComponent = (props: Props) => {

    const {booth, shop} = props;

    if (!booth) {
        return <Redirect to={{pathname: ShopsRoutes.index(), state: {refresh: true}}}/>
    }

    return (
        <div>
            <div className="row expanded">
                <BreadcrumbsComponent>
                    <li>
                        <a href="javascript: history.go(-1)">
                            Back
                        </a>
                    </li>
                    <li>{booth.toString()}</li>
                </BreadcrumbsComponent>

            </div>

            <div className="row expanded">
                <div className="large-12 columns">
                    <div className="text-group mt-1 mb-1">
                        <h4>{booth.toString()}</h4>
                    </div>
                </div>
            </div>

            {booth.images.length > 0 &&
                <div className="row expanded">
                    <div className="large-12 columns">
                        <CarouselComponent images={booth.images}/>
                    </div>
                </div>
            }

            <div className="row">
                <div className="large-12 columns">
                    <div className="flex-container">
                        <div className="media-object">
                            <div className="media-object-section logo middle">
                                <div className="img-wrapper small-img-fit">
                                    <img src={shop.imageUrl()} />
                                </div>
                            </div>
                            <div className="media-object-section middle">
                                <span className="h4">{shop.toString()}</span>
                                <p className="subheader"><small>{shop.address()}</small></p>
                            </div>
                        </div>
                        <Link to={ShopsRoutes.view(shop.id)} className="button primary hollow small pull-right">View Shop Profile</Link>
                    </div>

                    <ul className="list-inline table justified">
                        <li className="text-center">
                            <div className="text-group">
                                <h5 className="subheader">Amount / Rate</h5>
                                <h3>${booth.price} {booth.terms}</h3>
                            </div>
                        </li>
                        <li className="text-center">
                            <div className="text-group">
                                <h5 className="subheader">Payment Method</h5>
                                <h3>{booth.paymentMethods().join(", ")}</h3>
                            </div>
                        </li>
                    </ul>

                </div>
            </div>

        </div>
    );
};


// WEBPACK FOOTER //
// ./app/client/booth/components/BoothProfileComponent.tsx